<template>
    <div>
        <form action="">
                <div class="modal-card">
                    <header class="modal-card-head">
                        <p class="modal-card-title has-text-white">Add a New Service Code</p>
                        <button
                            type="button"
                            class="delete"
                            @click="$emit('close')"/>
                    </header>
                    <section class="modal-card-body has-background-dvodark">
                        <b-field label="Code">
                            <b-input
                                class="is-dvodark"
                                type="text"
                                v-model="code"
                                placeholder="Enter a code"
                                required>
                            </b-input>
                        </b-field>
                        <b-field label="Description">
                            <b-input
                                type="text"
                                v-model="description"
                                placeholder="Enter a description"
                                required>
                            </b-input>
                        </b-field>
                    </section>
                    <footer class="modal-card-foot">
                        <b-button class="is-dvogreen" @click="createService">Create Service Code</b-button>
                    </footer>
                </div>
        </form>
    </div>
</template>

<script>
import { API } from 'aws-amplify';
import { createService } from '../graphql/mutations'
export default {
    data(){
    return{
        code: null,
        description: null
        }
    },
    methods:{
    async createService() {
    const { code, description  } = this;
    const Service = { code, description };
    const temporaryStorage = await API.graphql({
      query: createService,
      variables: {input: Service},
    });
    const valToPass = temporaryStorage.data.createService
    this.code = ''
    this.description = ''
    this.$emit('close', valToPass);
    }
}}
</script>
